//@flow
import * as React from 'react';
import { Field, reduxForm, formValueSelector,change } from 'redux-form';
import { connect } from 'react-redux';
import ContainerRowSpace from '../../components/common/ContainerRowSpace'
import ContainerRowReduxReadonlyTextAndOverrideField from './common/ContainerRowReduxReadonlyTextAndOverrideField'
import ContainerRowReduxTextField from './common/ContainerRowReduxTextField'
import ContainerRowReduxHideTextFieldIfOverride from './common/ContainerRowReduxHideTextFieldIfOverride'
import * as actions from '../../redux/demeter/actions';

const cancelButtonOnClick=(e,props)=>{
    e.preventDefault();
    props.cancelAddInvItemForm();
}

const refreshLineTotal=(props)=>{
    const { itemQty,itemPrice } = props;
    let itemTotal=0
    if (itemQty && itemPrice){
        itemTotal=itemQty * itemPrice
    }
    props.changeFieldValue('itemTotal',itemTotal)
}

const refreshLineQtyForLineTotal=(e,props)=>{
    const { itemPrice } = props;
    let lineTotal = 0
    if (e.target.value && itemPrice){
        lineTotal = e.target.value * itemPrice
    }
    props.changeFieldValue('itemTotal',lineTotal)
}

const isOverrideLineQty=(e,props)=>{
    if (e.target.checked){
        props.changeFieldValue('itemQty',null)
        refreshLineQtyForLineTotal(e,props)
    }
}

const itemPriceOnChange=(e,props)=>{
    const { demeter,itemQty } = props;
    
    let itemTotal=0
    if (itemQty && e.target.value){
        itemTotal=itemQty * e.target.value
    }
    props.changeFieldValue('itemTotal',itemTotal)
}

const isOverrideNaItemPriceOnChange=(e,props)=>{
    if (e.target.checked){
        props.changeFieldValue('itemPrice',null)
        itemPriceOnChange(e,props)
    }
}

const SaveAndCancelButtons=props=>(
    <div className='row'>
        <div className="col-sm">
            <button className="btn btn-outline-primary" type="submit" disabled={props.pristine || props.submitting}>
                Save
            </button>
            &nbsp;&nbsp;&nbsp;
            <button className="btn btn-outline-secondary" type="button" onClick={(e)=>cancelButtonOnClick(e,props)}>
                Cancel
            </button>
        </div>
    </div>
)

const Title=props=>(
    <div className='row'>
        <div className='col-sm'>
            <h5>Add/Edit Invoice Items</h5>
        </div>
    </div>
)

const AddInvoiceItemForm = props => {
    const { handleSubmit,pristine,submitting, isOverrideItemTotal, initialValues, isOverrideNaItemQty,isOverrideNaItemPrice  } = props;
    
    return (
          <div className='container'>
            <ContainerRowSpace /> 
            <ContainerRowSpace /> 
            <Title />
            <form onSubmit={handleSubmit} >
                <ContainerRowReduxTextField field={'itemDesc'} label={'Line Description'} />
                
                <ContainerRowReduxHideTextFieldIfOverride 
                    textField={'itemQty'} textLabel={'Line Quantity'} textType={'number'}
                    checkboxField={'isOverrideNaItemQty'} checkboxLabel={'Line Quantity not available in Document'}
                    isOverride={isOverrideNaItemQty} textOnChangeFunc={refreshLineQtyForLineTotal} 
                    checkboxOnChangeFunc={isOverrideLineQty} parentProps={props}
                />
                
                <ContainerRowReduxHideTextFieldIfOverride 
                    textField={'itemPrice'} textLabel={'Line Price'} textType={'number'}
                    checkboxField={'isOverrideNaItemPrice'} checkboxLabel={'Line Price not available in Document'}
                    isOverride={isOverrideNaItemPrice} textOnChangeFunc={itemPriceOnChange} 
                    checkboxOnChangeFunc={isOverrideNaItemPriceOnChange} parentProps={props}
                />
                
                <ContainerRowReduxReadonlyTextAndOverrideField 
                    textField={'itemTotal'} textLabel={'Line Total'} textType={'number'}
                    checkboxField={'isOverrideItemTotal'} checkboxLabel={'Override this field'}
                    isOverride={isOverrideItemTotal} notOverrideFunc={refreshLineTotal} 
                    parentProps={props}
                />

                <SaveAndCancelButtons {...props}/>
            </form>
            <ContainerRowSpace /> 
          </div>  
        
    )
}

const validate = (values,props) => {
    const errors = {};
    const { isOverrideItemTotal,demeter }=props;
    
    let requiredFields = [
        'itemDesc'
    ];

    if (!values['isOverrideNaItemPrice']){
        requiredFields.push('itemPrice')
    }
    
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Required'
        }
    })

    return errors;
}

const submit = (values, dispatch, props) => {
    const { jwt,taskAcceptedInfoId,demeter } = props;
    let newInvItem=values;
    const { demeterItem } = demeter;
    
    if (demeterItem && demeterItem.id){
        props.updateDemeterItem(jwt,values,demeterItem.id);
    }else{
        props.createNewDemeterItem(jwt,newInvItem,taskAcceptedInfoId);
    }
}

const form='demeterAddInvItemForm'

const AddInvItemReduxForm = reduxForm({
    form: form,
    enableReinitialize: true,
    validate,
    onSubmit: submit,
})(AddInvoiceItemForm)

const selector = formValueSelector(form)

const mapStateToProps:any = (state, ownProps) => {
    return {
        demeter: state.demeter,
        isOverrideItemTotal: selector(state, 'isOverrideItemTotal'),
        isOverrideNaItemQty: selector(state, 'isOverrideNaItemQty'),
        isOverrideNaItemPrice: selector(state, 'isOverrideNaItemPrice'),
        itemTotal: selector(state, 'itemTotal'),
        itemQty: selector(state, 'itemQty'),
        itemPrice: selector(state, 'itemPrice'),
        initialValues: state.demeter.demeterItem
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
      createNewDemeterItem: (jwt,newDemeterItem,taskAcceptedInfoId) => {
        dispatch(actions.createNewDemeterItem(jwt,newDemeterItem,taskAcceptedInfoId))  
      },
      updateDemeterItem: (jwt,updateDemeterItem,id) => {
        dispatch(actions.updateDemeterItem(jwt,updateDemeterItem,id))  
      },
      cancelAddInvItemForm: () => {
        dispatch(actions.cancelAddInvItemForm())  
      },
      refreshDemeterItem: (demeterItem)=>{
        dispatch(actions.refreshDemeterItem(demeterItem))  
      },
      changeFieldValue: (field, value)=> {
        dispatch(change(form, field, value))
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(AddInvItemReduxForm);


// WEBPACK FOOTER //
// ./src/views/ProjectDemeter/AddInvoiceItemForm.js